/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import styles from './social-media-links.module.scss';

const FRAME_HEIGHT = '436';
const FRAME_WIDTH = '626';

const Facebook = ({ props = {} }) => {
  const {shareable, href} = props

  if (!href) {
    return null;
  }

  const onFacebookClick = () => {
    window.open(href, 'share_to_facebook', `width=${FRAME_WIDTH},height=${FRAME_HEIGHT}`)
  }

return (
  <a
    data-testid="facebook-element"
    className=""
    href={href}
    title="facebook"
    target= "_blank"
    rel="nofollow"
    onClick = {shareable && onFacebookClick}
>
      <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" style={{ paddingRight: '5px' }}>
        <g id="MW---Katie" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="blog/author-bio/v3" transform="translate(-27.000000, -542.000000)" fill="#666666" fillRule="nonzero">
            <g id="Organism-/-ALP-/-Card-/-Project-Guide-Initial-Copy-7" transform="translate(10.000000, 282.000000)">
              <g id="Path-3" transform="translate(17.000000, 260.000000)">
                <path d="M25,12.5759799 C25,5.63089499 19.403125,0 12.5,0 C5.596875,0 0,5.63089499 0,12.5759799 C0,18.8534898 4.57083333,24.0557535 10.546875,24.998952 L10.546875,16.2114861 L7.37291667,16.2114861 L7.37291667,12.5749319 L10.546875,12.5749319 L10.546875,9.80612031 C10.546875,6.65478935 12.4135417,4.91301614 15.26875,4.91301614 C16.6354167,4.91301614 18.0666667,5.15929575 18.0666667,5.15929575 L18.0666667,8.25403479 L16.4895833,8.25403479 C14.9364583,8.25403479 14.4520833,9.22343324 14.4520833,10.2179837 L14.4520833,12.5759799 L17.91875,12.5759799 L17.3645833,16.2125341 L14.4520833,16.2125341 L14.4520833,25 C20.4291667,24.0557535 25,18.8524418 25,12.5759799 Z" id="Path" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </a>
  );
};

Facebook.propTypes = {
  props: object.isRequired
};

Facebook.displayName = 'Facebook';

export { Facebook };
